export const regexEscape = s => {
  return s.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&')
}
